import { useMutation } from "@tanstack/react-query";
import type { CreateRetractationReturnRequestDto, ReturnRequestDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { SESSION_TOKEN_KEY } from "./use-session-token";

export async function publicCreateRetractationReturnRequest(
  payload: CreateRetractationReturnRequestDto,
): Promise<ReturnRequestDto> {
  const token = localStorage.getItem(SESSION_TOKEN_KEY) ?? "";
  const { data, response } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/retractation",
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      body: payload as any,
      params: { header: { authorization: `Bearer ${token}` } },
    },
  );
  if (!response.ok) throw new Error("Failed to create retractation return request");
  return data as ReturnRequestDto;
}

export function usePublicCreateRetractationReturnRequest() {
  return useMutation({ mutationFn: publicCreateRetractationReturnRequest });
}
